import { bag } from './bag';
import { csv } from './csv';
import { dxf } from './dxf';
import { excel } from './excel';
import { geojson } from './geojson';
import { geopackage } from './geopackage';
import { geotiff } from './geotiff';
import { gml } from './gml';
import { las } from './las';
import { shapefile } from './shapefile';
import { sld } from './sld';
import { text } from './text';

const data_format = {
	bag,
    csv,
	dxf,
	excel,
	geojson,
	geopackage,
	geotiff,
	gml,
	las,
	shapefile,
	sld,
	text
}

export {
	data_format
}